import { Button, ControlGroup, NumericInput, Tag } from "@blueprintjs/core";
import React from "react";
import { compareTwoObjects, niceDate } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { nanoid } from "nanoid";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import SingleIDSelectWrapper from "../utils/SingleIDSelectWrapper";
import { DateInput } from "@blueprintjs/datetime";

class SxAnaesthetistSchedule extends React.Component {
  state = {
    changed: false,
    site: null,
    anaesthetistId: null,
    anaesthetistName: null,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    validFrom: new Date(),
    validTo: new Date(),
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }

  renderWeekdaySchedule = (day) => {
    return (
      <Button
        minimal
        small
        text={this.state[day] ? "Available" : "Not Available"}
        icon={this.state[day] ? "endorsed" : "warning-sign"}
        intent={this.state[day] ? "success" : "warning"}
        onClick={() => {
          this.setState({ [day]: !this.state[day] }, () => {
            this.props.onUpdate(compareTwoObjects(this.state, this.props.data));
          });
        }}
      />
    );
  };
  render() {
    return (
      <>
        <td>
          {this.state.anaesthetistId ? (
            <ControlGroup vertical>
              <Tag intent="primary" large multiline>
                {this.state.anaesthetistName}
              </Tag>
              <Button
                icon="edit"
                onClick={() =>
                  this.setState(
                    { anaesthetistId: null, anaesthetistName: null },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  )
                }
              />
            </ControlGroup>
          ) : (
            <SingleIDSelectWrapper
              showSelectProp={true}
              width="200px"
              items={this.props.docs.map((each) => {
                return {
                  ...each,
                  searchName: `${each.shortcode || ""} | ${each.name}`,
                };
              })}
              selectedItem={this.state.selectedSurgeon}
              labelKey="searchName"
              onChange={(item) => {
                this.setState(
                  {
                    anaesthetistId: item._id,
                    anaesthetistName: item.name,
                    selectedSurgeon: item,
                    changed: true,
                  },
                  () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                );
              }}
            />
          )}
        </td>
        <td>
          <SingleSelectWrapper
            items={this.props.sites}
            selectedItem={this.state.site}
            onChange={(item) =>
              this.setState({ site: item, changed: true }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              )
            }
          />
        </td>
        <td>
          {this.state.validFrom ? (
            <ControlGroup>
              <Tag
                intent="primary"
                minimal
                large
                onRemove={() =>
                  this.setState({ validFrom: null }, () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                  )
                }
              >
                {niceDate(this.state.validFrom)}
              </Tag>
            </ControlGroup>
          ) : (
            <DateInput
              minDate={new Date("1900")}
              value={this.state.validFrom || null}
              formatDate={(date) => niceDate(date)}
              parseDate={(str) => new Date(str)}
              onChange={(value) =>
                this.setState({ validFrom: value }, () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
                )
              }
              maxDate={new Date("2100")}
              placeholder="From"
            />
          )}
        </td>
        <td>
          {this.state.validTo ? (
            <ControlGroup>
              <Tag
                intent="primary"
                minimal
                large
                onRemove={() =>
                  this.setState({ validTo: null }, () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                  )
                }
              >
                {niceDate(this.state.validTo)}
              </Tag>
            </ControlGroup>
          ) : (
            <DateInput
              minDate={new Date("1900")}
              value={this.state.validTo || null}
              formatDate={(date) => niceDate(date)}
              parseDate={(str) => new Date(str)}
              onChange={(value) =>
                this.setState({ validTo: value }, () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
                )
              }
              maxDate={new Date("2100")}
              placeholder="To"
            />
          )}
        </td>
        <td>{this.renderWeekdaySchedule("monday")}</td>
        <td>{this.renderWeekdaySchedule("tuesday")}</td>
        <td>{this.renderWeekdaySchedule("wednesday")}</td>
        <td>{this.renderWeekdaySchedule("thursday")}</td>
        <td>{this.renderWeekdaySchedule("friday")}</td>
        <td>{this.renderWeekdaySchedule("saturday")}</td>
        <td>{this.renderWeekdaySchedule("sunday")}</td>
      </>
    );
  }
}

export default inject("authStore")(observer(SxAnaesthetistSchedule));
